import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('canningProcess', 'canningProcesses');

const customActions = {
  async LOAD_canningProcesses({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('canningProcesses')
      .query({
        $filter: 'IsDeleted eq false AND status ne null',
        $expand: 'StockItem',
      });
    commit('SET_canningProcesses', data);
    return data;
  },
};

export default { ...actions, ...customActions };
